"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsGroupFocused = void 0;
var _react = require("react");
var useIsGroupFocused = exports.useIsGroupFocused = function useIsGroupFocused(_ref) {
  var focusedOption = _ref.focusedOption;
  return (0, _react.useCallback)(function (option) {
    return option === focusedOption;
  }, [focusedOption]);
};